// 契約の作成（portal.md「契約選択画面」/ POST /admin/contracts）。system-admin のみ。
// 作成後はマッピングを登録するため組織設定へ（サービス利用はサービス利用画面）。

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, ApiError, messageFor, type Me } from "../lib/api";
import { currentUser, signIn } from "../lib/auth";
import { SystemHeader } from "./Header";

export function CreateContractPage() {
  const nav = useNavigate();
  const [me, setMe] = useState<Me | null>(null);
  const [contractId, setContractId] = useState("");
  const [name, setName] = useState("");
  const [legalName, setLegalName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      if (!(await currentUser())) { await signIn(); return; }
      try { setMe(await api.me()); } catch (e) { setError(messageFor(e)); }
    })();
  }, []);

  if (!me) return <main>{error ? <p className="error">{error}</p> : <p className="muted">読み込み中…</p>}</main>;
  if (me.platformRole !== "system-admin") return <main><p className="error">{messageFor(new ApiError(403, "forbidden"))}</p></main>;

  const create = async (e: React.FormEvent) => {
    e.preventDefault();
    const id = contractId.trim();
    setBusy(true); setError(null);
    try { await api.createContract({ contractId: id, name: name.trim(), legalName: legalName.trim() }); nav(`/c/${id}/settings`); }
    catch (err) { setError(messageFor(err)); setBusy(false); }
  };

  return (
    <>
      <SystemHeader me={me} />
      <main className="narrow">
        <h1>契約を作成</h1>
        {error && <p className="error">{error}</p>}
        <form onSubmit={create}>
          <label htmlFor="contractId">契約 ID（英小文字・数字・_。先頭は英小文字か数字。後から変更できません）</label>
          <input id="contractId" type="text" value={contractId} onChange={(e) => setContractId(e.target.value)} />
          <label htmlFor="legalName">正式名称（契約書上の会社名。システム管理者だけが変更できます）</label>
          <input id="legalName" type="text" value={legalName} placeholder="株式会社〇〇" onChange={(e) => setLegalName(e.target.value)} />
          <label htmlFor="name">表示名（契約の管理者も変更できます）</label>
          <input id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} />
          <p className="muted">作成後、組織設定で認証ソースマッピングを、サービス利用画面でサービス利用を登録します。サブシステム側に会社の行を先に作ってください。</p>
          <p className="row">
            <button className="primary" type="submit" disabled={busy || !contractId.trim() || !legalName.trim() || !name.trim()}>作成</button>
            <button type="button" onClick={() => nav("/select")}>キャンセル</button>
          </p>
        </form>
      </main>
    </>
  );
}
